/**
 * Merges Opticomm resources onto one of `@medusajs/js-sdk`'s namespace objects
 * (`sdk.store`, `sdk.admin`).
 *
 * Those namespaces are class instances holding a `private client`, so they
 * cannot be subclassed — assigning onto the instance is the supported way to
 * extend them. The merge is one level deep on purpose: when Opticomm adds
 * routes to a resource Medusa already ships (custom `/store/products/...`
 * routes belong on the existing `store.product`, not a rival `store.products`),
 * those methods are folded into the upstream object rather than shadowing it.
 *
 * A key that would overwrite an existing *method* is a bug in codegen, not
 * something to resolve at runtime, so it throws.
 */
export const mergeResources = (target, resources) => {
    const mutableTarget = target;
    for (const [name, resource] of Object.entries(resources)) {
        const existing = mutableTarget[name];
        if (existing === undefined) {
            mutableTarget[name] = resource;
            continue;
        }
        if (typeof existing !== "object" || existing === null) {
            throw new TypeError(`Cannot merge Opticomm resource "${name}" onto a non-object`);
        }
        const existingResource = existing;
        for (const method of Object.keys(resource)) {
            if (method in existingResource) {
                throw new TypeError(`Opticomm resource "${name}.${method}" would overwrite an existing method`);
            }
        }
        Object.assign(existingResource, resource);
    }
    return target;
};
//# sourceMappingURL=merge.js.map